import React from 'react'
import firebase from 'firebase/app'
import Select from 'common/components/Select'
import Row, { RowSpacer } from '../../../../common/components/Row'
import Text from '../../../../common/components/Text'
import Hr from '../../../../common/components/Hr'

const sneak = (userId, e) => {
  if (e.target.value === 'basic') {
    firebase
      .database()
      .ref(`/users/${userId}/subscription`)
      .set(null)
  } else {
    firebase
      .database()
      .ref(`/users/${userId}/subscription`)
      .set({
        id: 'fakeSub',
        nextBillingDate: '2020-01-01',
        nextBillingPeriodAmount: '111',
        paidThroughDate: '2020-01-01',
        planId: e.target.value,
        price: '111',
        status: 'Active',
        statusHistory: [
          {
            balance: '0.00',
            currencyIsoCode: 'AUD',
            planId: e.target.value,
            price: '111',
            status: 'Active',
            subscriptionSource: 'api',
            timestamp: '2018-03-15T01:10:49Z',
            user: 'services@p22.studio'
          }
        ]
      })
  }
}

const TestPlanSwitcher = ({ userId }) => {
  if (
    process.env.REACT_APP_CONFIG &&
    process.env.REACT_APP_CONFIG !== 'development'
  )
    return null
  return (
    <>
      <Hr />
      <Row>
        <Text>Switch plans (dev only)</Text>
        <RowSpacer />
        <Select onChange={e => sneak(userId, e)} defaultValue="">
          <option disabled value="">
            Select
          </option>
          <option value="basic">basic</option>
          <option value="personal">personal</option>
          <option value="pro">pro</option>
          <option value="10-block">10-block</option>
          <option value="1mb">1mb</option>
        </Select>
      </Row>
    </>
  )
}

export default TestPlanSwitcher
